import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, X } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../App';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ImpersonationBanner = () => {
  const impersonation = localStorage.getItem('impersonation');
  const { login } = useAuth();
  const navigate = useNavigate();

  if (!impersonation) return null;

  const data = JSON.parse(impersonation);

  const exitImpersonation = async () => {
    const adminToken = data.adminToken;
    const adminUser = data.adminUser;

    // Clear impersonation state first
    localStorage.removeItem('impersonation');

    // Restore admin session via auth context (no full page reload)
    login(adminUser, adminToken);
    localStorage.setItem('activeRole', 'admin');

    // Log the exit on the backend
    try {
      await fetch(`${API_URL}/api/admin/exit-impersonate`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${adminToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          impersonated_user_id: data.targetUserId,
          impersonated_email: data.targetEmail,
        }),
      });
    } catch {
      // Silent — don't block exit if logging fails
    }

    navigate('/admin/dashboard?tab=users');
  };

  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-white" data-testid="impersonation-banner">
        <div className="max-w-screen-2xl mx-auto px-4 py-2 flex items-center justify-between">
          <div className="flex items-center gap-2 text-sm font-medium">
            <Shield className="h-4 w-4" />
            <span>ADMIN MODE — Acting as {data.targetName} ({data.targetEmail})</span>
          </div>
          <Button
            size="sm"
            variant="ghost"
            onClick={exitImpersonation}
            className="text-white hover:bg-amber-600 h-7 gap-1"
            data-testid="exit-impersonation-btn"
          >
            <X className="h-3.5 w-3.5" />
            Exit Impersonation
          </Button>
        </div>
      </div>
      {/* Spacer to push page content below the fixed banner */}
      <div className="h-10" />
    </>
  );
};

export default ImpersonationBanner;
